import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { ActionTypes } from 'modules/experiments/ducks/actionTypes';
import { CampaignResponse } from 'modules/experiments/takeover/types';
import { CHOOSE_CAMPAIGN_COLUMNS } from 'modules/experiments/types';
import { PaginationUpdateEvent } from 'ui/paginationFooter';

export const openChooseCampaignDrawer = () => ({
  type: ActionTypes.OPEN_CHOOSE_CAMPAIGN,
});

export const closeChooseCampaignDrawer = () => ({
  type: ActionTypes.CLOSE_CHOOSE_CAMPAIGN,
});

export const fetchChooseCampaignResponse = (data: CampaignResponse) => ({
  type: ActionTypes.FETCH_CHOOSE_CAMPAIGN_RESPONSE,
  payload: data,
});

export const setChooseCampaignPaginationInfo = (paginationInfo: PaginationUpdateEvent) => ({
  type: ActionTypes.SET_CHOOSE_CAMPAIGN_PAGINATION_INFO,
  payload: paginationInfo,
});

export const refetchCampaigns = () => ({
  type: ActionTypes.REFETCH_CAMPAIGNS,
});

export const setChooseCampaignSearch = (search: string) => ({
  type: ActionTypes.SET_CAMPAIGN_SEARCH,
  payload: { search },
});

export const setChooseCampaignSortBy = (sortBy: CHOOSE_CAMPAIGN_COLUMNS) => ({
  type: ActionTypes.SET_CHOOSE_CAMPAIGN_SORT_BY,
  payload: { sortBy },
});

export const setChooseCampaignSortDirection = (sortDirection: SORT_DIRECTIONS) => ({
  type: ActionTypes.SET_CHOOSE_CAMPAIGN_SORT_DIRECTION,
  payload: { sortDirection },
});
